import angular from 'angular'

import { analyticsDataFrameCard } from '../analytics/directives/analytics-data-frame-card/analytics-data-frame-card.directive'
import { analyticsDataFrameLineChart } from '../analytics/directives/analytics-data-frame-line-chart/analytics-data-frame-line-chart.directive'
import { analyticsDataFrameBarChart } from '../analytics/directives/analytics-data-frame-bar-chart/analytics-data-frame-bar-chart.directive'
import { analyticsDataFrameGroupedDonut } from '../analytics/directives/analytics-data-frame-grouped-donut/analytics-data-frame-grouped-donut.directive'
import { analyticsDonutChart } from '../analytics/directives/analytics-data-frame-big-card-donut/components/donut-chart/donut-chart.directive'
import { analyticsFilterSelect } from '../analytics/directives/analytics-filter-select/analytics-filter-select.directive'
import { analyticsErrorDataFrame } from '../analytics/directives/analytics-error-data-frame/analytics-error-data-frame.directive'
import { analyticsEmptyMode } from '../analytics/directives/analytics-empty-mode/analytics-empty-mode.directive'

const module = angular
  .module('deskfy.analyticsShared', [])
  .directive('analyticsDataFrameCard', analyticsDataFrameCard)
  .directive('analyticsDataFrameLineChart', analyticsDataFrameLineChart)
  .directive('analyticsDataFrameBarChart', analyticsDataFrameBarChart)
  .directive('analyticsDataFrameGroupedDonut', analyticsDataFrameGroupedDonut)
  .directive('analyticsDonutChart', analyticsDonutChart)
  .directive('analyticsFilterSelect', analyticsFilterSelect)
  .directive('analyticsErrorDataFrame', analyticsErrorDataFrame)
  .directive('analyticsEmptyMode', analyticsEmptyMode)

export const analyticsSharedModule = module
